import React from 'react';

const Hero = () => {
    return (
        <section className="hero-section text-white text-center py-20 md:py-32">
            <div className="container mx-auto px-6">
                <h1 className="text-4xl md:text-6xl font-serif-display font-bold mb-4 leading-tight">Clarity in a Complex World.</h1>
                <p className="text-lg md:text-xl text-gray-300 mb-8 max-w-3xl mx-auto">Smarter insurance with YuktiEnsure.</p>
                <a href="#contact" className="bg-sky-500 hover:bg-sky-600 text-white font-bold py-3 px-8 rounded-full text-lg transition duration-300">Schedule a Risk Consultation</a>
            </div>
        </section>
    );
};

export default Hero;